class BgScroll {
  constructor(element) {
    this.element = element;
    this.sections = this.element.querySelectorAll('.fotile-grid-item');
    this.observeSection = this.observeSection.bind(this);
    this.init();
  }

  observeSection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // this.element.classList.forEach(className => {
        //   if (className.startsWith('change-bg-color')) {
        //     console.log("class exists");
        //     this.element.classList.remove(className);
        //   }
        // });
        this.element.classList.add("change-bg-color");
      } else {
        this.element.classList.remove("change-bg-color");
      }
    });
  }  

  init() {
    const observer = new IntersectionObserver(this.observeSection, { rootMargin: '-50% 0% -50% 0%' });
    this.sections.forEach(section => {
      observer.observe(section);
    });
  }
}

